<template>
  <div style="padding-bottom:20px;">
    <div class="linePart">
      <el-carousel height="353px" indicator-position="none" class="carousel" v-if="line3Data.length>0">
        <el-carousel-item v-for="(item,index) in line3Data[0].list"  :key="item.index" class="carouselItem" >
          <div @click="judgmentTurn(item)">
            <div class="carouselImg">
              <img :src="item.imageUrl"></img>
            </div>
            <h3 class="carouselTitle">{{item.title}}</h3>
          </div>
        </el-carousel-item>
      </el-carousel>
      <card-item :limit="9" :Data="line1DataRight" v-if="line1DataRight.length>1"></card-item>
    </div>
    <div class="linePart"  v-if="lineImg.length>0">
      <img class="carecImg" :src="item.url" v-for="(item,index) in  lineImg[0].list" @click="toBlank(item)" :key="index"></img>
    </div>
    <div class="linePart">
      <card-item :limit="8" :Data="line2DataLeft"  v-if="line2DataLeft.length>0"></card-item>
      <card-item :limit="8" :Data="line2DataRight"  v-if="line2DataRight.length>0"></card-item>
    </div>
    <div class="linePart">
      <card-item :limit="6" :Data="line3DataLeft"  v-if="line3DataLeft.length>0"></card-item>
      <card-item :limit="6" :Data="line3DataRight"  v-if="line3DataRight.length>0"></card-item>
    </div>
  </div>
</template>

<script>
import { selArticleByType } from "@/api/main";
import cardItem from '../Info/committeeCardItem.vue'
import newList from '../Info/newList.vue'
export default {
  name: "Logged",
  components:{
    cardItem,
    newList
  },
  data() {
    return {
      Info1: {
        type: 4, // 新闻类型1，2，3
        pageNumber: 1, // 第几页
        pageSize: 5, // 每页条数
      },
      lineImg: [],
      line1DataRight: [],
      line2DataLeft: [],
      line2DataRight: [],
      line3DataLeft: [],
      line3DataRight: [],
      line3Data: []
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    toDetail(item){
      var routeData =  this.$router.resolve({
        path: `/committee/Content`,
        query: {
          type:this.line3Data[0].title,
          typeId:this.line3Data[0].typeId,
          articleId: item.id
        }
      });
      window.open(routeData.href, '_blank');
    },
    downloadView(item){
      window.open(item.url)
    },
    judgmentTurn(item){
      if(item.imageUrl){
        this.downloadView(item)
      } else {
        this.toDetail(item)
      }
    },
    toBlank(item){
      // var routeData =  this.$router.resolve({
      //   path: `/committee/Content`,
      //   query: {
      //     type:this.line3Data[0].title,
      //     typeId:this.line3Data[0].typeId,
      //     articleId: item.id
      //   }
      // });
      if(item.introduce){

        window.open(item.introduce, '_blank');
      }
    },
    getdata() {
      var that = this
      var data = {
        page:0
      }

      var line1DataRight = {...data,typeId: '4028b8817f25b0eb017f25bb51460015',size:9}
      selArticleByType(line1DataRight).then((resp) => {
        var info = {
          title:'评优评先',
          typeId: '4028b8817f259ca4017f25b02e8d0003',
          list: resp.data.content
        }
        this.line1DataRight.push(info)
      })
      setTimeout(function(){
        var line1DataRight = {...data,typeId: '4028b8817f259ca4017f25af28530001',size:7}
        selArticleByType(line1DataRight).then((resp) => {
          var info = {
            title:'行业动态',
            typeId: '4028b8817f259ca4017f25af28530001',
            list: resp.data.content
          }
          that.line1DataRight.push(info)
        })
      },100)

      var line2DataLeft1 = {...data,typeId: '4028b8817f25b0eb017f25b9263c000e',size:8}
      selArticleByType(line2DataLeft1).then((resp) => {
        var info = {
          title:'法律法规',
          typeId: '4028b8817f259ca4017f25afdb2f0002',
          list: resp.data.content
        }
        this.line2DataLeft.push(info)
        
      })
      
      var line2DataRight = {...data,typeId: '4028b8817f25b0eb017f25b71d3d0009',size:8}
      selArticleByType(line2DataRight).then((resp) => {
        var info = {
          title:'教育培训',
          typeId: '4028b8817f25b0eb017f25b71d3d0009',
          list: resp.data.content
        }
        this.line2DataRight.push(info)
      })

      var line3DataLeft = {...data,typeId: '4028b8817f297703017f299ab549001c',size:6}
      selArticleByType(line3DataLeft).then((resp) => {
        var info = {
          title:'资质资格',
          typeId: '4028b8817f297703017f299ab549001c',
          list: resp.data.content
        }
        this.line3DataLeft.push(info)
        
      })
      
      var line3DataRight = {...data,typeId: '4028b8817f25b0eb017f25b74944000a',size:6}
      selArticleByType(line3DataRight).then((resp) => {
        var info = {
          title:'业务交流',
          typeId: '4028b8817f25b0eb017f25b74944000a',
          list: resp.data.content
        }
        this.line3DataRight.push(info)
      })

      var line3Data = {...data,typeId: '4028b8817f25b0eb017f25b83bef000b',size:1000}
      selArticleByType(line3Data).then((resp) => {
        let res = resp.data.content
        let list = res.filter(el=>{
          return el.imageUrl != null
        })
        console.log(list)
        var info = {
          title:'首页',
          typeId: '4028b8817f25b0eb017f25b83bef000b',
          list: list
        }
        this.line3Data.push(info)
      })

      var lineImg = {...data,typeId: '4028b8817f297703017f2996b1020013',size:3}
      selArticleByType(lineImg).then((resp) => {
        var info = {
          title:'首页图片',
          typeId: '4028b8817f297703017f2996b1020013',
          list: resp.data.content
        }
        this.lineImg.push(info)
      })
      
    },
    insurance(id, title) {
      this.$router.push({
        path: "/committee/Info",
        query: {
          type: title,
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped>
.linePart {
  display: flex;
  width: 100%;
  
  margin-top: 20px;
  /* padding-bottom: 20px; */
  justify-content: space-between;
}
.carousel{
  width: 590px;
  /* background: skyblue; */
}
.carousel h3{
  width: 100%;
  height: 100%;
  background: #fff;
}
.carousel .carouselItem{
  width: 100%;
  height: 100%;
  position: absolute;
}
.carousel .carouselItem .carouselImg{
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: skyblue;
}
.carousel .carouselItem .carouselImg img{
  position: relative;
  z-index: 100;
  width: 100%;
  height: 353px;
}
.carousel .carouselItem .carouselTitle{
  position: relative;
  height: 40px;
  line-height: 40px;
  left: -1px;
  right: 0;
  bottom: 44px;
  z-index: 101;
  font-size: 14px;
  padding: 0 
  15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #d9d5d2;
  background: #5b5e60;
}
.carecImg{
  width: 390px;
  cursor: pointer;
  height: 145px;
  background: skyblue;
}
</style>
